module.exports = __webpack_public_path__ + "static/lunchtype22-regular-webfont-f19fcf1d01c6bc9e71f446c81538d830.ttf";